import { useCallback, useState } from "react";

import { useHandleResize } from "./useHandleResize";

type WindowSizeData = {
  innerHeight: number;
  innerWidth: number;
  outerHeight: number;
  outerWidth: number;
};

function getSize(): WindowSizeData {
  const isServer = typeof window === "undefined";

  if (isServer) {
    return {
      innerHeight: 0,
      innerWidth: 0,
      outerHeight: 0,
      outerWidth: 0,
    };
  }

  return {
    innerHeight: window.innerHeight,
    innerWidth: window.innerWidth,
    outerHeight: window.outerHeight,
    outerWidth: window.outerWidth,
  };
}

export function useWindowSize() {
  const [windowSize, setWindowSize] = useState<WindowSizeData>(getSize());

  const updateWindowSize = useCallback(() => {
    setWindowSize(getSize());
  }, []);

  useHandleResize(updateWindowSize);

  return windowSize;
}
